// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  width: 90%;
  margin: 15px auto;
}

h3 {
  font-family: AppFontBold, sans-serif;
  margin-top: 15px;
  margin-bottom: 5px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 12px;
  font-size: 16px;
}

ion-input {
  --padding-start: 10px !important;
}

ion-item {
  --border-width: 1px !important;
  --border-color: #E5E5E5;
  --border-bottom: none;
  --background: #fff;
  border: none;
  color: #313131;
}

ion-icon {
  width: 25px;
  height: 25px;
  cursor: pointer;
}

.stacked {
  position: relative;
  top: 8px;
  left: 5%;
  z-index: 2;
  font-family: AppFont;
  font-weight: 400;
  font-size: 11px;
  line-height: 85%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  text-transform: capitalize;
  color: #807D7D;
  background: #fff;
  padding: 0 5px;
}

.cross {
  height: 26px;
  width: 26px;
  cursor: pointer;
  margin: 0px;
  background: var(--color-white-accent);
  width: 35px;
  height: 35px;
  padding: 0px;
  z-index: 99;
}
.cross ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.cross:hover {
  background: #f2dbd9;
}

.button-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  gap: 12px;
}
.button-block ion-button {
  width: 100%;
  min-height: 40px;
  --background: #2D69AA;
  color: white;
  font-size: 14px;
}
ion-icon {
  z-index: 10;
}

span {
  margin: 10px 0px;
}

.email-msg {
  margin: 0px;
  margin-bottom: 0px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 8px;
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/app-restore-password-modal/app-restore-password-modal.component.scss"],"names":[],"mappings":"AAEA;EACC,UAAA;EACA,iBAAA;AADD;;AAGA;EACC,oCAAA;EACA,gBAAA;EACA,kBAAA;EACG,yBAAA;EACA,sBAAA;EACA,mBAAA;EACH,eAAA;AAAD;;AAEA;EACC,gCAAA;AACD;;AACA;EACC,8BAAA;EAEA,uBAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;AACD;;AACA;EACC,WAAA;EACA,YAAA;EACA,eAAA;AAED;;AAAA;EACC,kBAAA;EACG,QAAA;EACA,QAAA;EACA,UAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;AAGJ;;AAAA;EACC,YAAA;EACA,WAAA;EACA,eAAA;EAEC,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AAEF;AADE;EACC,WAAA;EACA,YAAA;EACA,WAAA;AAGH;AADE;EACC,mBAAA;AAGH;;AAAA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACG,SAAA;AAGJ;AAFC;EACO,WAAA;EACN,gBAAA;EACA,qBAAA;EACA,YAAA;EACM,eAAA;AAIR;AAEA;EACC,WAAA;AAAD;;AAEA;EACC,gBAAA;AACD;;AACA;EACC,WAAA;EACA,kBAAA;EACG,yBAAA;EACA,sBAAA;EACA,kBAAA;EACH,eAAA;AAED","sourcesContent":["@import '../../../theme/mixins';\n\n.wrapper {\n\twidth: 90%;\n\tmargin: 15px auto;\n}\nh3 {\n\tfont-family: AppFontBold, sans-serif;\n\tmargin-top: 15px;\n\tmargin-bottom: 5px;\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n    margin-bottom: 12px;\n\tfont-size: 16px;\n}\nion-input {\n\t--padding-start: 10px !important;\n}\nion-item {\n\t--border-width: 1px !important;\n\t// --border-radius: 52px !important;\n\t--border-color: #E5E5E5;\n\t--border-bottom: none;\n\t--background: #fff;\n\tborder: none;\n\tcolor: #313131;\n}\nion-icon {\n\twidth: 25px;\n\theight: 25px;\n\tcursor: pointer;\n}\n.stacked {\n\tposition: relative;\n    top: 8px;\n    left: 5%;\n    z-index: 2;\n    font-family: AppFont;\n    font-weight: 400;\n    font-size: 11px;\n    line-height: 85%;\n    letter-spacing: 0%;\n    text-align: center;\n    vertical-align: middle;\n    text-transform: capitalize;\n    color: #807D7D;\n    background: #fff;\n    padding: 0 5px;\n}\n\n.cross {\n\theight: 26px;\n\twidth: 26px;\n\tcursor: pointer;\n\n\t\tmargin: 0px;\n\t\tbackground: var(--color-white-accent);\n\t\twidth: 35px;\n\t\theight: 35px;\n\t\tpadding: 0px;\n\t\tz-index: 99;\n\t\tion-icon {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tmargin: 0px;\n\t\t}\n\t\t&:hover {\n\t\t\tbackground: #f2dbd9;\n\t\t}\n}\n.button-block {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tmargin-top: 10px;\n    gap: 12px;\n\tion-button {\n        width: 100%;\n\t\tmin-height: 40px;\n\t\t--background: #2D69AA;\n\t\tcolor: white;\n        font-size: 14px;\n\t\t&:hover {\n\t\t\t// --background: #FC5E07 !important\n\t\t}\n\t}\n}\nion-icon {\n\tz-index: 10;\n}\nspan {\n\tmargin: 10px 0px;\n}\n.email-msg {\n\tmargin: 0px;\n\tmargin-bottom: 0px;\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n    margin-bottom: 8px;\n\tfont-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
